module.exports = __webpack_public_path__ + "static/media/sort-down.b818a16a.svg";